<template>
  <div
    class="signup-page"
    :class="{ 'final': final }"
  >
    <div
      class="star-field"
      v-if="final && desktop"
    >
      <div class="group-left">
        <b
          class="decoration svg-star-signup"
          :class="{ 'start': starTransition }"
        />
        <b
          class="decoration svg-star-signup"
          :class="{ 'start': starTransition }"
        />
        <b
          class="decoration svg-star-signup"
          :class="{ 'start': starTransition }"
        />
      </div>
      <div class="group-right">
        <b
          class="decoration svg-star-signup"
          :class="{ 'start': starTransition }"
        />
        <b
          class="decoration svg-star-signup"
          :class="{ 'start': starTransition }"
        />
        <b
          class="decoration svg-star-signup"
          :class="{ 'start': starTransition }"
        />
      </div>
    </div>
    <div
      class="signup-page-content"
    >

      <div class="page-title-wrapper">
        <h1>{{ title }}</h1>
        <div class="valid-indicator-container">
          <div
            v-if="final"
            class="finished-indicator"
          >
            <div
              class="star-fill"
              :style="{ display: final ? 'block' : 'none' }"
            />
            <i
              class="fa fa-check-circle"
              :style="{ display: final ? 'block' : 'none' }"
            />
          </div>
          <div
            v-else
          >
            <svg
              class="valid-indicator"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
            >
              <circle
                cx="12"
                cy="12"
                r="8"
                fill="transparent"
                stroke="#EFEFEF"
                stroke-width="5"
              />
            </svg>
            <transition-group name="bulge">
              <svg
                class="valid-indicator valid-indicator-progress"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                key="svg"
              >
                <circle
                  cx="12"
                  cy="12"
                  r="8"
                  fill="transparent"
                  stroke="#80C442"
                  stroke-width="5"
                  stroke-linecap="round"
                  stroke-dasharray="100"
                  :stroke-dashoffset="indicatorValue"
                />
              </svg>
              <div
                class="valid-indicator indicate-valid"
                v-if="allValid"
                key="valid"
              >
                <i class="fa fa-check-circle"/>
              </div>
              <div
                class="valid-indicator indicate-invalid"
                v-if="oneInvalid"
                key="invalid"
              >
                <i class="fa fa-exclamation-circle"/>
              </div>
            </transition-group>
          </div>
        </div>
      </div>

      <p
        class="message"
        v-html="message"/>

      <slot>
        This will only be displayed if there is no content
        to be distributed.
      </slot>

    </div>
  </div>
</template>

<script>
export default {
  props: {
    step: {
      type: Number,
      default: 0
    },
    desktop: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'title missing'
    },
    message: {
      type: String,
      default: 'message missing'
    },
    inputs: {
      type: Number,
      default: 0
    },
    finished: {
      type: Number,
      default: 0
    },
    final: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      indicatorValue: 100,
      allValid: false,
      oneInvalid: false,
      starTransition: true
    }
  },
  activated: function () {
    this.$nextTick(function () {
      // sends event to App.vue reporting the current route string
      if (this.$route.path !== '/') {
        let path = this.$route.path.split('/')[1]
        this.$events.$emit('route-updated', path)
      }
      setTimeout(() => {
        this.starTransition = false
      }, 1500)
    })
  },
  watch: {
    finished: function (newVal, oldVal) {
      this.applyFinishedPercentage()
    },
    inputs: function (newVal, oldVal) {
      this.applyFinishedPercentage()
    }
  },
  methods: {
    applyFinishedPercentage () {
      // 45 is full 100 is empty
      // Because svg ok
      let percentageFull = this.finished / this.inputs
      this.indicatorValue = 100 - Math.round(55 * (percentageFull))
      console.log(this.indicatorValue)

      if (this.indicatorValue <= 45) {
        this.allValid = true
      } else {
        this.allValid = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/library/page.vue